import type { DefaultProps } from "./types"

export const defaultProps: DefaultProps = {
  size: 16,
  variant: "default",
  style: {},
}

export const lazyDefaultProps: DefaultProps = defaultProps

export const fallbackColorByMode = {
  default: "#0810C6",
  dark: "#272730",
  light: "#fff",
}
